import { TenantResource } from "client/resources";
import { combineReducers, Reducer } from "redux";

import { TenantMissingVariableResource } from "../../client/resources/tenantMissingVariablesResource";

enum ActionKeys {
    TENANT_FETCHED = "TENANT_FETCHED",
    TENANT_SAVED = "TENANT_SAVED",
    TENANT_VARIABLES_FETCHED = "TENANT_VARIABLES_FETCHED",
    TENANT_ENABLED_FETCHED = "TENANT_ENABLED_FETCHED",
    OTHER_ACTION = "__any_other_action_type__"
}

interface ITenantAction {
    type: ActionKeys;
}

interface ITenantFetchedAction {
    type: ActionKeys.TENANT_FETCHED;
    tenant: TenantResource;
}

interface ITenantSavedAction {
    type: ActionKeys.TENANT_SAVED;
    tenant: TenantResource;
}

interface ITenantVariablesFetchedAction {
    type: ActionKeys.TENANT_VARIABLES_FETCHED;
    hasMissingVariables: boolean;
}

interface IOtherAction {
    type: ActionKeys.OTHER_ACTION;
}

type ActionTypes =
    ITenantFetchedAction |
    ITenantSavedAction |
    ITenantVariablesFetchedAction |
    IOtherAction;

export interface TenantsAreaState {
    readonly currentTenant: TenantState;
}

export interface TenantState {
    readonly name: string;
    readonly logoUrl: string;
    readonly id: string;
    readonly hasMissingVariables: boolean;
}

const currentTenantReducer: Reducer<TenantState> = (state: TenantState = null, action: ActionTypes): TenantState => {
    switch (action.type) {
        case ActionKeys.TENANT_SAVED:
        case ActionKeys.TENANT_FETCHED:
            const tenant = action.tenant as TenantResource;
            return {
                name: tenant.Name,
                logoUrl: tenant.Links.Logo,
                id: tenant.Id,
                hasMissingVariables: false
            };
        case ActionKeys.TENANT_VARIABLES_FETCHED:
            return {
                ...state,
                hasMissingVariables: action.hasMissingVariables
            };
        default:
            return state;
    }
};

export const tenantsActions = {
    tenantFetched: (tenant: TenantResource): ITenantFetchedAction => {
        return { type: ActionKeys.TENANT_FETCHED, tenant};
    },
    tenantSaved: (tenant: TenantResource): ITenantSavedAction => {
        return { type: ActionKeys.TENANT_SAVED, tenant};
    },
    tenantMissingVariablesFetched: (tenantMissingVariables: TenantMissingVariableResource): ITenantVariablesFetchedAction => {
        return {
            type: ActionKeys.TENANT_VARIABLES_FETCHED,
            hasMissingVariables: !!tenantMissingVariables
        };
    }
};

export const tenantsArea = combineReducers<TenantsAreaState>({
    currentTenant: currentTenantReducer
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/tenants/tenantsArea.ts